<template>
  <div>
    <div v-if="!isLoad">
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-main style="padding: 0px" class="">
          <!-- <div class="overflow-hidden" style="height: calc(100vh - 64px)"> -->
          <!-- Active Tab Component -->
          <ActitiveTabcomponent
            :tabs="visibleTabs"
            :default-tab="activeTab"
            :inside-dialog="false"
            @tab-changed="handleTabChange"
          >
            <!-- Tab Actions Slot - wraps filter and export buttons -->
            <template v-slot:tab-buttons="{ activeTab }">
              <div class="flex items-center space-x-2">
                <!-- Dedicated Daily Filter for Map Tab -->
                <div v-if="activeTab === 'map'" class="flex items-center mr-2">
                  <v-menu
                    v-model="employeeDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    left
                    origin="top right"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="$dayjs(selectedDate).format('DD MMM, YYYY')"
                        label="Select Date"
                        placeholder="Select Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        outlined
                        solo
                        flat
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                        style="width: 160px"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="selectedDate"
                      @input="
                        employeeDateMenu = false
                        onDateSelected()
                      "
                      :max="$dayjs().format('YYYY-MM-DD')"
                      scrollable
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </div>

                <div v-if="activeTab !== 'calendar'" class="flex items-center space-x-2">
                  <div v-if="activeTab === 'map'">
                    <v-btn
                      :loading="exportLoading"
                      v-iam-disabled="'team_review.map.export'"
                      :color="$vuetify.theme.currentTheme.primary"
                      class="white--text normal-case"
                      :class="[$vuetify.breakpoint.lgAndUp || tabs !== 2 ? '' : 'w-fit']"
                      @click="exportMapData"
                      v-show="isExportButtonVisible"
                    >
                      <v-icon left dark>mdi-download</v-icon>
                      Export
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-menu
                      offset-y
                      v-iam-disabled="
                        activeTab === 'attendance'
                          ? 'team_review.attendance.export'
                          : 'team_review.roster.export'
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :loading="exportLoading"
                          v-iam-disabled="
                            activeTab === 'attendance'
                              ? 'team_review.attendance.export'
                              : 'team_review.roster.export'
                          "
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text normal-case"
                          :class="[$vuetify.breakpoint.lgAndUp ? '' : 'w-fit']"
                          v-on="on"
                          v-show="isExportButtonVisible"
                        >
                          <v-icon left dark>mdi-download</v-icon>
                          Export
                        </v-btn>
                      </template>
                      <v-list v-if="roasterTab" v-show="isFeatureVisible('DOWNLOAD_ROSTER')">
                        <v-list-item class="text-sm" @click="exportShiftData"
                          >Download Shift Data</v-list-item
                        >
                      </v-list>
                      <v-list v-else v-show="isFeatureVisible('DOWNLOAD_REPORT')">
                        <v-list-item class="text-sm" @click="downloadCheckInUsers"
                          >Attendance Report (&rarr;)</v-list-item
                        >
                        <!-- <v-list-item class="text-sm" @click="downloadUsersData"
                        >Muster Report</v-list-item
                      >
                      <v-list-item class="text-sm" @click="exportTimeSeries"
                        >Muster Report-II</v-list-item
                      > -->
                        <v-list-item class="text-sm" @click="downloadMusterReport3"
                          >MUSTER REPORT</v-list-item
                        >
                        <v-list-item class="text-sm" @click="exportTaskData"
                          >Download
                          {{ firstSubCaseTabName?.visitTable?.displayName || 'Visit/Task' }}
                          Data</v-list-item
                        >
                      </v-list>
                      <!-- Add close tag for v-menu here or ensure it matches structure -->
                    </v-menu>
                  </div>

                  <!-- Column Selector Icon - Directly opens v-select dropdown below the icon -->
                  <div class="column-selector-container" v-if="activeTab === 'attendance'">
                    <v-icon
                      size="28px"
                      v-iam-disabled="'team_review.attendance.manage_columns'"
                      class="cursor-pointer text-grey"
                      @click="openColumnSelect"
                    >
                      mdi-format-columns
                    </v-icon>
                    <v-select
                      ref="columnSelect"
                      v-model="selectedColumns"
                      :items="visibleSubColumnOptions"
                      item-value="label"
                      item-text="label"
                      multiple
                      chips
                      label="Select Columns"
                      hide-details
                      solo
                      flat
                      outlined
                      dense
                      v-if="!roasterTab"
                      :color="$vuetify.theme.currentTheme.primary"
                      class="hidden-column-select"
                    >
                      <v-list-item
                        class="pl-4 pt-0 select-all-item"
                        slot="prepend-item"
                        @click="toggleSelectAllColumn"
                      >
                        <v-list-item-action>
                          <v-icon :color="selectedColumns.length > 0 ? 'blue darken-2' : ''">{{
                            iconColumn
                          }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Select All</v-list-item-title>
                      </v-list-item>
                      <v-divider slot="prepend-item" />
                      <template v-slot:selection="{ item, index }">
                        <v-chip small v-if="index < 1" class="chip-text-div">
                          <span class="chip-text">{{ item.label }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text text-caption">
                          (+{{ selectedColumns.length - 1 }} more)
                        </span>
                      </template>
                    </v-select>
                  </div>

                  <FilterPopOver v-if="activeTab !== 'map'" :selectedCount="selectedCount">
                    <v-card outlined class="w-72 max-h-96">
                      <div>
                        <div class="flex items-center" v-if="tabs === 2">
                          <v-label> Matrix </v-label>
                          <v-switch
                            :ripple="false"
                            class="ml-4 flex justify-start items-center custom-switch"
                            inset
                            dense
                            v-model="graphicalView"
                          ></v-switch>
                          <v-label> Graph </v-label>
                        </div>
                      </div>
                      <v-col
                        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
                        :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
                        v-if="!graphicalView && tabs === 2"
                        class="pb-0"
                      >
                        <v-select
                          label="Select Status"
                          placeholder="Select Status"
                          v-model="selectedTaskStatus"
                          :items="taskSteps"
                          item-text="value"
                          item-value="key"
                          hide-details
                          solo
                          flat
                          multiple
                          small-chips
                          clearable
                          outlined
                          dense
                          :color="$vuetify.theme.currentTheme.primary"
                        >
                          <v-list-item
                            class="pl-4 select-all-item"
                            slot="prepend-item"
                            @click="toggleSelectAll"
                          >
                            <v-list-item-action>
                              <v-icon
                                :color="selectedTaskStatus.length > 0 ? 'blue darken-2' : ''"
                                >{{ icon }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item>
                          <v-divider slot="prepend-item" />
                          <template v-slot:selection="{ item, index }">
                            <v-chip small v-if="index < 1">
                              <span class="chip-text">{{ item.value }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text text-caption">
                              (+{{ selectedTaskStatus.length - 3 }} more)
                            </span>
                          </template>
                        </v-select>
                      </v-col>

                      <v-col
                        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
                        :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
                        class="pb-0"
                      >
                        <v-select
                          v-model="dateRangeType"
                          :items="dateRangeTypes"
                          label="Date Range Type"
                          hide-details
                          solo
                          flat
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col
                        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
                        :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
                        class="pb-0"
                      >
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          class="checkBorder_a"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              label="Select Date Range"
                              placeholder="Select Date Range"
                              v-model="formattedMonth"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              hide-details
                              solo
                              flat
                              outlined
                              dense
                              class="checkBorder"
                              clearable
                              @click:clear="onDateCleared"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-if="dateRangeType === 'Monthly'"
                            v-model="selectedDate"
                            @input="onDateSelected"
                            :min="minDate"
                            :max="maxDate"
                            type="month"
                            scrollable
                          />

                          <v-date-picker
                            v-show="dateRangeType === 'Custom Date'"
                            v-model="customDates"
                            :min="minDate"
                            :max="maxDate"
                            range
                            scrollable
                            type="date"
                            @input="onCustomDateSelected"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
                        :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
                      >
                        <v-select
                          v-model="employeeStatus"
                          :items="['ACTIVE', 'INACTIVE']"
                          label="Status"
                          hide-details
                          solo
                          flat
                          outlined
                          dense
                          @change="handleInput"
                        ></v-select>
                      </v-col>
                      <!-- <v-col
            :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
            :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
          >
            <v-text-field
              label="Employee Name"
              placeholder="Employee Name"
              v-model="employeeSearch"
              prepend-inner-icon="mdi-magnify"
              persistent-hint
              hide-details
              solo
              flat
              clearable
              @input="handleInput"
              outlined
              dense
            ></v-text-field>
          </v-col> -->

                      <div
                        :class="[$vuetify.breakpoint.lgAndUp ? 'ml-3' : 'mr-auto ml-3 mt-2 mb-4']"
                        v-if="roasterTab"
                        v-show="isFeatureVisible('ASSIGN_SHIFTS_TO_EMPLOYEE') && canWrite"
                      >
                        <v-btn
                          :color="$vuetify.theme.currentTheme.primary"
                          class="white--text"
                          dark
                          @click.stop="toggleDrawer"
                        >
                          Shift Details
                        </v-btn>
                      </div>
                    </v-card>
                  </FilterPopOver>
                </div>
              </div>
            </template>

            <!-- Tab Content Slots -->
            <template v-for="tab in visibleTabs" v-slot:[tab.key]="">
              <!-- Calendar & Map tabs: wrap in common sidebar -->
              <template v-if="tab.key === 'calendar' || tab.key === 'map'">
                <TeamReviewSidebar
                  :key="`sidebar-${tab.key}`"
                  :employees="employees"
                  :current-page="currentPage"
                  :total-pages="totalPages"
                  :selected-user-id="selectedUserId"
                  :search.sync="employeeSearch"
                  @page-change="onPageChange"
                  @select-user="onUserSelected"
                >
                  <component
                    :key="tab.key"
                    :is="tab.component"
                    :task-steps="taskSteps"
                    :orgConfig="orgConfig"
                    :employees="employees"
                    :teamData="teamData"
                    :view="graphicalView"
                    :search="search"
                    :selectedTaskStatus="selectedTaskStatus"
                    :selected-columns="selectedColumns"
                    :customDates="customDates"
                    :startOfMonth="startOfMonth"
                    :endOfMonth="endOfMonth"
                    :userIds="userIds"
                    :dateRangeType="dateRangeType"
                    @updateTeamData="updateTeamData"
                    @cancel="cancel"
                    ref="exportReport"
                    :date-range-type="dateRangeType"
                    :menu.sync="menu"
                    :formatted-month.sync="formattedMonth"
                    :selected-date.sync="selectedDate"
                    :employee-selected-date="employeeSelectedDate"
                    :custom-dates.sync="customDates"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :date-range-types="dateRangeTypes"
                    @update-date-range-type="onDateRangeTypeChange"
                    @onDateCleared="onDateCleared"
                    @onDateSelects="onDateMonthSelected"
                    @onCustomDateSelects="onCustomDateSelecteds"
                    :apiLoading="apiLoading"
                    :location-history="tab.key === 'timeline' ? timelineData : undefined"
                    :selected-user-id="tab.key === 'map' ? selectedUserId : undefined"
                    :userLiveLocation="tab.key === 'map' ? timelineData : undefined"
                    :timelineData="tab.key === 'map' ? timelineData : undefined"
                    :focusedUserId="tab.key === 'map' ? selectedUserId : undefined"
                    :userId="tab.key === 'calendar' ? selectedUserId : undefined"
                    @timeline-data="handleTimelineData"
                    @switch-to-timeline-tab="switchToTimelineTab"
                    @view-timeline="handleViewTimeline"
                  />
                </TeamReviewSidebar>
              </template>

              <!-- All other tabs render normally -->
              <component
                v-else
                :key="tab.key"
                :is="tab.component"
                :task-steps="taskSteps"
                :orgConfig="orgConfig"
                :employees="employees"
                :teamData="teamData"
                :view="graphicalView"
                :search="search"
                :selectedTaskStatus="selectedTaskStatus"
                :selected-columns="selectedColumns"
                :customDates="customDates"
                :startOfMonth="startOfMonth"
                :endOfMonth="endOfMonth"
                :userIds="userIds"
                :dateRangeType="dateRangeType"
                @updateTeamData="updateTeamData"
                @cancel="cancel"
                ref="exportReport"
                :date-range-type="dateRangeType"
                :menu.sync="menu"
                :formatted-month.sync="formattedMonth"
                :selected-date.sync="selectedDate"
                :employee-selected-date="employeeSelectedDate"
                :custom-dates.sync="customDates"
                :min-date="minDate"
                :max-date="maxDate"
                :date-range-types="dateRangeTypes"
                @update-date-range-type="onDateRangeTypeChange"
                @onDateCleared="onDateCleared"
                @onDateSelects="onDateMonthSelected"
                @onCustomDateSelects="onCustomDateSelecteds"
                :apiLoading="apiLoading"
                :location-history="tab.key === 'timeline' ? timelineData : undefined"
                :selected-user-id="tab.key === 'map' ? selectedUserId : undefined"
                :userLiveLocation="tab.key === 'map' ? timelineData : undefined"
                :timelineData="tab.key === 'map' ? timelineData : undefined"
                :focusedUserId="tab.key === 'map' ? selectedUserId : undefined"
                :userId="tab.key === 'calendar' ? selectedUserId : undefined"
                @timeline-data="handleTimelineData"
                @switch-to-timeline-tab="switchToTimelineTab"
                @view-timeline="handleViewTimeline"
              />
              <RoasterTable
                v-if="tab.roasterComponent"
                :key="`${tab.key}-roaster`"
                :is="roasterTab"
                :orgConfig="orgConfig"
                :teamData="teamData"
                :startOfMonth="startOfMonth"
                :endOfMonth="endOfMonth"
                :customDates="customDates"
                :dateRangeType="dateRangeType"
                :roasterDrawer="roasterDrawer"
                :search="employeeSearch"
              />
              <TimeLineNewVue
                v-if="tab.key === 'timeline'"
                :key="`${tab.key}-duplicate`"
                ref="duplicateTimeLine"
              />
              <v-pagination
                :key="`${tab.key}-pagination`"
                v-model="currentPage"
                :length="totalPages"
                :total-visible="5"
                v-if="
                  currentTab &&
                  totalPages > 1 &&
                  !renderTable &&
                  activeTab !== 'map' &&
                  activeTab !== 'calendar'
                "
                :color="$vuetify.theme.currentTheme.primary"
              ></v-pagination>
            </template>
          </ActitiveTabcomponent>
          <DailyVisitExport :employeeData="employeeArray" />
          <ExportMusterReport3
            :employeeData="employeeArray"
            :teamData="teamData"
            :startDate="startOfMonth"
            :endDate="endOfMonth"
            :attendanceSettings="orgConfig"
          />
          <ExportTimeSeriesToExcel
            :teamData="teamData"
            :startDate="startOfMonth"
            :endDate="endOfMonth"
            :attendanceSettings="orgConfig"
          />
          <!-- </div> -->
        </v-main>
      </template>
      <TeamReview_mobile v-else />
    </div>
    <div v-else class="absolute w-full h-screen flex-col items-center flex justify-center">
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
  </div>
</template>

<script>
import AttendanceTable from '@/components/Workforce/AttendanceManagement/AttendancePage.vue'
import DailyVisitExport from '@/components/Workforce/AttendanceManagement/DailyVisitExport.vue'
import {
  debounce,
  isModuleFeatureAllowed,
  hasPermission,
  fullName,
  downloadExcel,
  getFullAddress
} from '@/utils/common'
import ExcelJS from 'exceljs'
import RoasterTable from '@/components/Workforce/AttendanceManagement/RoasterTable.vue'
import { hasIamPermission } from '@/utils/iamEvaluator'
import { TAB_ITEMS, SearchConfig } from '@/utils/workforce/constants'
import FilterPopOver from '@/components/FilterPopOver.vue'
import ActitiveTabcomponent from '@/components/ActitiveTabcomponent.vue'
import TeamReviewCalendar from '@/components/Workforce/AttendanceManagement/TeamReviewCalendar.vue'
import MapView from '@/components/Workforce/EmployeeManagement/MapView.vue'
import TeamReviewSidebar from '@/components/Workforce/TeamReviewSidebar.vue'
import { axiosUrl } from '@/utils/workforceApi'
import TeamReview_mobile from './TeamReview_mobile.vue'

export default {
  name: 'SchedulerPage',
  layout: 'Workforce/default',
  components: {
    TeamReview_mobile,
    DailyVisitExport,
    AttendanceTable,
    RoasterTable,
    FilterPopOver,
    ActitiveTabcomponent,
    TeamReviewCalendar,
    MapView,
    TeamReviewSidebar,
    ExportMusterReport3: () =>
      import('@/components/Workforce/AttendanceManagement/ExportMusterReport3.vue'),
    ExportTimeSeriesToExcel: () =>
      import('@/components/Workforce/AttendanceManagement/ExportTimeSeriesToExcel.vue')
  },
  provide() {
    return {
      teamReviewContext: this
    }
  },
  data() {
    return {
      userOrg: this.$storage.getUniversal('user'),
      userData: this.$store.state.wfmPermissions,
      subCases: this.$store.state.subCases,
      tabs: 0,
      taskSteps: [],
      teamData: [],
      employeeSearch: '',
      search: '',
      orgConfig: null,
      exportReport: null,
      isCheckedIn: true,
      menu: false,
      exportLoading: false,
      graphicalView: true,
      selectedCount: 1,
      employeeStatus: 'ACTIVE',
      selectedTaskStatus: ['COMPLETED', 'MISSED'],
      selectedColumns: [
        'Attendance',
        'First Clock-In',
        // 'Last Clock-In',
        'Last Clock-Out'
      ],
      subColumnOptions: [
        { label: 'Attendance', visible: true },
        { label: 'First Clock-In', visible: true },
        // { label: 'Last Clock-In', visible: true },
        { label: 'Last Clock-Out', visible: true },
        { label: 'Working Hours', visible: true },
        // { label: 'Status', visible: true },
        { label: 'Overtime', visible: true },
        {
          label: 'Clock-In Image',
          visible: this.isAttendanceFeature('CLOCKIN_WITH_SELFIE')
        },
        {
          label: 'Clock-Out Image',
          visible: this.isAttendanceFeature('CLOCKOUT_WITH_SELFIE')
        },
        { label: 'Delay In Shift', visible: true },
        { label: 'Breaks Count', visible: true },
        { label: 'Distance (km)', visible: true }
      ],
      checkInOptions: [
        { text: 'Clocked In', value: true },
        { text: 'Not Clocked In', value: false }
      ],
      dateRangeType: 'Monthly',
      dateRangeTypes: ['Monthly', 'Custom Date'],
      employeeDateMenu: false,
      selectedDate: this.$dayjs().format('YYYY-MM-DD'),
      startOfMonth: '',
      endOfMonth: '',
      customDates: [],
      testModel: [],
      totalPages: null,
      currentPage: 1,
      userIds: [],
      employeeArray: [],
      isLoad: true,
      roasterDrawer: false,
      apiLoading: false,
      parallelCallDateRange: 12,
      timelineData: null,
      selectedUserId: null,
      employees: [],
      // New data property for column selector menu
      columnSelectorMenu: false,
      lastLocationFetchKey: null,
      lastLocationFetchTime: 0
    }
  },
  watch: {
    currentPage: {
      handler(newPage) {
        if (newPage) {
          this.onDateSelected()
          this.disablePagination = true
        }
      },
      immediate: true
    },
    employeeSearch: {
      handler(val) {
        this.search = val
        this.debouncedFetchUsers()
      }
    },
    '$route.query.search': {
      handler(inputVal) {
        try {
          this.search = inputVal
          this.currentPage = 1
          this.debouncedFetchUsers()

          if (this.activeTab === 'map' && inputVal && this.isValidObjectId(inputVal)) {
            this.selectedUserId = inputVal
            this.fetchLocationData(inputVal)
          }
        } catch (error) {
          console.log(error)
        }
      },
      immediate: true
    },
    roasterTab: {
      handler() {
        this.roasterDrawer = false
      }
    },
    activeTab: {
      handler(newTab) {
        this.onDateSelected()
        this.customDates = []
      }
    }
  },
  methods: {
    hasIamPermission(statements, actionKey) {
      return hasIamPermission(statements, actionKey)
    },
    onPageChange(page) {
      this.currentPage = page
    },
    onUserSelected(user) {
      this.selectedUserId = user._id
      if (this.activeTab === 'map') {
        this.fetchLocationData(user._id)
      }
    },
    tabVisible(key) {
      if (key == 'attendance') {
        return hasIamPermission(this.iamStatements, 'team_review.attendance.read')
      } else if (key == 'map') {
        return hasIamPermission(this.iamStatements, 'team_review.map.read')
      } else if (key == 'calendar') {
        return hasIamPermission(this.iamStatements, 'team_review.calendar.read')
      } else if (key == 'roaster') {
        return hasIamPermission(this.iamStatements, 'team_review.roster.read')
      }
      return false
    },
    handleTabChange(tabKey) {
      if (this.$route.query.activeTab !== tabKey) {
        this.$router.replace({
          query: { ...this.$route.query, activeTab: tabKey }
        })
      }
    },
    onDateRangeTypeChange(newType) {
      this.dateRangeType = newType
    },
    onDateCleared() {
      this.selectedDate = null
      this.customDates = []
    },
    onDateMonthSelected(date) {
      this.selectedDate = date
      this.onDateSelected()
    },
    onCustomDateSelecteds(dates) {
      this.customDates = dates
    },
    async fetchTaskSteps() {
      try {
        const response = await this.$axios.get(`/task/steps`)

        const taskStepsArray = []

        for (const key in response.data.taskSteps) {
          if (Object.prototype.hasOwnProperty.call(response.data.taskSteps, key)) {
            taskStepsArray.push({
              key: key,
              value: response.data.taskSteps[key]
            })
          }
        }

        this.taskSteps = taskStepsArray
      } catch (error) {
        console.log(error)
      }
    },
    async getConfig() {
      try {
        const response = await this.$axios.get('/org/config')

        const data = response.data?.config
        return data || {}
      } catch (error) {
        console.error('Error fetching config:', error)
      }
    },
    async fetchDataInIntervals(apiEndpoint, moduleName) {
      try {
        let paramsArray = []
        const userIdChunks = []
        const batchSize = 5

        for (let i = 0; i < this.userIds.length; i += 12) {
          userIdChunks.push(this.userIds.slice(i, i + 12)?.join(','))
        }

        if (this.dateRangeType === 'Monthly' && this.userIds.length > 12) {
          const daysInMonth = this.$dayjs(this.endOfMonth).format('DD')

          for (let start = 1; start <= daysInMonth; start += this.parallelCallDateRange) {
            const end = Math.min(start + (this.parallelCallDateRange - 1), daysInMonth)
            userIdChunks.forEach((userIds) => {
              paramsArray.push({
                start: this.$dayjs(this.startOfMonth).date(start).format('YYYY-MM-DD'),
                end: this.$dayjs(this.endOfMonth).date(end).format('YYYY-MM-DD'),
                userIds
              })
            })
          }
        } else if (this.dateRangeType === 'Monthly' && this.userIds.length <= 12) {
          paramsArray.push({
            start: this.startOfMonth,
            end: this.endOfMonth,
            userIds: this.userIds.join(',')
          })
        } else if (this.dateRangeType === 'Custom Date') {
          userIdChunks.forEach((userIds) => {
            paramsArray.push({
              start: this.$dayjs(this.customDates[0]).format('YYYY-MM-DD'),
              end: this.$dayjs(this.customDates[1]).format('YYYY-MM-DD'),
              userIds
            })
          })
        }

        this.apiLoading = true
        const results = []

        for (let i = 0; i < paramsArray.length; i += batchSize) {
          const batch = paramsArray.slice(i, i + batchSize)
          const requests = batch.map((params) => this.$axios.get(apiEndpoint, { params }))
          const responses = await Promise.all(requests)
          results.push(...responses.flatMap((response) => response.data[moduleName] || []))
        }

        this.apiLoading = false
        return results
      } catch (error) {
        console.error(`Error fetching data from ${apiEndpoint}:`, error)
        return []
      }
    },
    async fetchTeam() {
      try {
        const fetchedTeamData = await this.fetchDataInIntervals(
          '/user/v2/attendance',
          'employeeAttendance'
        )

        const attendanceMap = {}
        fetchedTeamData.forEach((attendance) => {
          const employeeId = attendance.userId._id
          if (!attendanceMap[employeeId]) {
            attendanceMap[employeeId] = []
          }
          attendanceMap[employeeId].push(attendance)
        })

        const transformedTeamData = []

        this.employees?.forEach((employee) => {
          const employeeId = employee._id

          if (Object.prototype.hasOwnProperty.call(attendanceMap, employeeId)) {
            attendanceMap[employeeId].forEach((el) => {
              transformedTeamData.push({
                ...el,
                profileImage: employee.systemUserId?.profileImage,
                userId: {
                  ...el.userId,
                  fullName: `${employee.systemUserId?.firstName} ${
                    employee.systemUserId?.lastName || ''
                  }`,
                  reportesTo: employee.reportesTo,
                  department: employee.department,
                  designation: employee.designation,
                  address: [employee.addressLine1, employee.city, employee.state]
                    .filter((v) => v)
                    .join(', ')
                }
              })
            })
          } else {
            transformedTeamData.push({
              userId: {
                ...employee,
                // name: employee.systemUserId?.firstName + ' ' + employee.systemUserId?.lastName,
                address: [employee.addressLine1, employee.city, employee.state]
                  .filter((v) => v)
                  .join(', ')
              },
              checkInOutData: [],
              attendanceDate: '',
              attendanceMarkedBySystem: false,
              profileImage: employee.systemUserId?.profileImage
            })
          }
        })
        this.teamData = transformedTeamData
      } catch (error) {
        console.error('Error fetching team data:', error)
      } finally {
        this.isLoad = false
      }
    },
    async fetchUsers(limit = 12) {
      try {
        const params = {
          limit,
          page: this.currentPage,
          sortBy: 'firstName',
          sortOrder: 'asc',
          status: this.employeeStatus
        }

        if (limit === '*') {
          params.page = 1
        }

        if (this.search) {
          if (this.isValidObjectId(this.search)) {
            params._id = this.search
          } else {
            params.search = this.search
          }
        }
        if (this.userOrg?.branch && !this.userOrg?.role?.includes('WFM_ADMIN')) {
          params.branch = this.userOrg?.branch
        }
        const response = await this.$axios.get(axiosUrl.users.getUsers, {
          params
        })
        this.employees = response.data?.users
        if (this.employees && this.employees.length > 0) {
          this.userIds = this.employees.map((user) => user._id)

          // If we filtered by ID (this.search is ID), find the user and set GlobalSearch input
          if (this.search && this.isValidObjectId(this.search)) {
            const matchedUser = this.employees.find((u) => u._id === this.search)
            if (matchedUser) {
              this.selectedUserId = matchedUser._id
              // If in Map View, fetch location data for this users
              if (this.activeTab === 'map') {
                this.fetchLocationData(matchedUser._id)
              }
              const userSelection = {
                name: SearchConfig.formatUserName(matchedUser),
                empId: matchedUser._id,
                empNumber: matchedUser.mobile
              }
              const wrapper = {
                text: `${userSelection.name} / ${
                  matchedUser.employmentDetails?.empId || matchedUser.employeeId || 'N/A'
                }`,
                value: userSelection
              }
              this.$store.dispatch('updateInputValue', wrapper)
            }
          }
        }
        this.totalPages = response.data?.pagination.totalPages
        await this.fetchTeam()
      } catch (error) {
        console.log(error)
      }
    },
    async fetchAllLocations() {
      try {
        const locationHistory = await this.fetchDataInIntervals(
          axiosUrl.users.getLocations,
          'locationHistory'
        )

        const employeeData = locationHistory.reduce((acc, location) => {
          const userId = location.userId?._id
          const matchedUser = this.employees?.find((el) => el._id === userId)
          const empRole = matchedUser?.wfmRole
          const empCity = matchedUser?.city
          const designation = matchedUser?.designation
          // console.log({ matchedUser })
          if (!acc[userId]) {
            acc[userId] = {
              fullName:
                fullName(matchedUser) !== '-'
                  ? fullName(matchedUser)
                  : location.userId?.fullName || fullName(location.userId),
              empId: location.userId?._id,
              empRole: empRole?.role || '-',
              empCity: empCity || '-',
              designation: designation || '-',
              employeeId:
                matchedUser?.employmentDetails?.empId ||
                matchedUser?.employeeId ||
                location.userId?.employeeId ||
                '-',
              locationData: [],
              branch: location.userId?.branch?.branchName,
              reportesTo: fullName(location.userId?.reportesTo)
            }
          }
          acc[userId].locationData.push(location)
          return acc
        }, {})

        this.employeeArray = Object.values(employeeData)
      } catch (error) {
        console.log(error)
      }
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.allTaskStatusSelected) {
          this.selectedTaskStatus = []
        } else {
          this.selectedTaskStatus = this.taskSteps.map((step) => step.key)
        }
      })
    },
    toggleSelectAllColumn() {
      this.$nextTick(() => {
        if (this.allColumnSelected) {
          this.selectedColumns = []
        } else {
          this.selectedColumns = this.visibleSubColumnOptions.map((step) => step.label)
        }
      })
    },

    async onDateSelected() {
      const selectedMonth = this.$dayjs(this.selectedDate).month()
      const currentMonth = this.$dayjs().month()
      const selectedYear = this.$dayjs(this.selectedDate).year()
      const currentYear = this.$dayjs().year()

      if (this.dateRangeType === 'Daily' || this.activeTab === 'map') {
        this.startOfMonth = this.$dayjs(this.selectedDate).format('YYYY-MM-DD')
        this.endOfMonth = this.$dayjs(this.selectedDate).format('YYYY-MM-DD')
      } else if (this.tabs === 0) {
        this.startOfMonth = this.$dayjs(this.selectedDate).startOf('month').format('YYYY-MM-DD')

        if (selectedMonth === currentMonth && selectedYear === currentYear) {
          this.endOfMonth = this.$dayjs().format('YYYY-MM-DD')
        } else {
          this.endOfMonth = this.$dayjs(this.selectedDate).endOf('month').format('YYYY-MM-DD')
        }
      } else if (this.tabs === 1) {
        this.startOfMonth = this.$dayjs(this.selectedDate).startOf('month').format('YYYY-MM-DD')
        this.endOfMonth = this.$dayjs(this.selectedDate).endOf('month').format('YYYY-MM-DD')
      }
      // Trigger user fetch for list/attendance views
      await this.fetchUsers()

      // If in Map View and a user is selected, refresh their location history too
      if (this.activeTab === 'map' && this.selectedUserId) {
        await this.fetchLocationData(this.selectedUserId)
      }
    },
    onCustomDateSelected(newDates) {
      if (newDates && newDates.length === 2) {
        this.customDates = newDates
        this.fetchTeam()
      }
    },
    // onDateCleared() {
    //   this.selectedDate = new Date().toISOString().substr(0, 10);
    //   this.fetchTeam();
    // },
    handleInput: async function () {
      this.search = this.employeeSearch
      this.debouncedFetchUsers()
    },
    async downloadCheckInUsers() {
      this.exportLoading = true
      try {
        await this.fetchUsers('*')
        this.$root.$emit('export-excel')
      } catch (error) {
        console.error('Error downloading check-in users:', error)
      } finally {
        this.exportLoading = false
      }
    },
    async downloadUsersData() {
      this.exportLoading = true
      try {
        this.currentPage = 1
        await this.fetchUsers('*')
        this.$root.$emit('export-format-excel')
      } catch (error) {
        console.error('Error downloading check-in users:', error)
      } finally {
        this.exportLoading = false
      }
    },
    async cancel() {
      await this.fetchUsers('12')
    },
    async exportTaskData() {
      this.exportLoading = true
      try {
        await this.fetchUsers('*')
        await this.fetchAllLocations()
        this.$root.$emit('export-daily-excel')
      } catch (error) {
        console.log(error)
      } finally {
        this.exportLoading = false
      }
    },
    async downloadMusterReport3() {
      this.exportLoading = true
      try {
        await this.fetchUsers('*')
        await this.fetchAllLocations()
        this.$root.$emit('export-muster-report-3')
      } catch (error) {
        console.error('Error downloading Muster Report 3:', error)
      } finally {
        this.exportLoading = false
      }
    },
    async exportShiftData() {
      this.exportLoading = true
      try {
        this.$root.$emit('export-data')
      } catch (error) {
        console.log(error)
      } finally {
        this.exportLoading = false
      }
    },
    async exportTimeSeries() {
      this.exportLoading = true
      try {
        await this.fetchUsers('*')
        this.$root.$emit('export-time-series-report')
      } catch (error) {
        console.error(error)
      } finally {
        this.exportLoading = false
      }
    },
    async exportMapData() {
      this.exportLoading = true
      try {
        if (!this.selectedUserId) {
          this.$toast.error('Please select a user to export data')
          return
        }

        const date = this.selectedDate

        // Use existing timeline data or fetch if empty
        let dataToExport = this.timelineData
        if (!dataToExport || dataToExport.length === 0) {
          try {
            const params = { date: this.selectedDate || this.$dayjs().format('YYYY-MM-DD') }
            const response = await this.$axios.get(`/location-time-series/${this.selectedUserId}`, {
              params
            })
            dataToExport = response.data?.data?.data || []
          } catch (e) {
            console.error('Error fetching time series for export:', e)
          }
        }

        if (!dataToExport || dataToExport.length === 0) {
          this.$toast.warning('No data available to export')
          return
        }

        // Create Workbook
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Finfi Admin'
        workbook.created = new Date()

        // --- SHEET 1: TRACKING DATA (Detailed Time Series) ---
        const trackingSheet = workbook.addWorksheet('Tracking Data')
        trackingSheet.columns = [
          { header: 'Employee Name', key: 'name', width: 25 },
          { header: 'Time', key: 'time', width: 22 },
          { header: 'Duration', key: 'duration', width: 15 },
          { header: 'Action', key: 'action', width: 20 },
          { header: 'Latitude', key: 'lat', width: 15 },
          { header: 'Longitude', key: 'lng', width: 15 },
          { header: 'Address', key: 'address', width: 45 },
          { header: 'Battery (%)', key: 'battery', width: 12 },
          { header: 'State', key: 'state', width: 15 }
        ]

        // Helper to format duration
        const formatDuration = (ms) => {
          if (!ms || ms < 0) ms = 0
          const seconds = Math.floor(ms / 1000)
          const h = Math.floor(seconds / 3600)
          const m = Math.floor((seconds % 3600) / 60)
          const s = seconds % 60

          if (h > 0) return `${h}h ${m}m ${s}s`
          if (m > 0) return `${m}m ${s}s`
          return `${s}s`
        }

        const processedRows = []
        let currentGroup = null

        // Ensure data is sorted by time
        dataToExport.sort((a, b) => {
          const t1 = this.$dayjs(a.createdAt || a.timestamp).valueOf()
          const t2 = this.$dayjs(b.createdAt || b.timestamp).valueOf()
          return t1 - t2
        })

        dataToExport.forEach((entry) => {
          const loc = entry.location || {}
          const coords = loc.coordinates || []
          const activity = entry.activity || {}
          const entryTime = this.$dayjs(entry.createdAt || entry.timestamp).valueOf()
          const pAddress =
            entry.state === 'STILL' ? (loc.address || entry.address || '').trim() : '-'
          const pPrefix = pAddress.split(',')[0].trim()

          const u = entry.userId || {}
          const employeeName =
            `${u.firstName || ''} ${u.lastName || ''}`.trim() ||
            this.getFullName(this.selectedUserId) ||
            'Unknown'

          // If STILL, try to group
          if (entry.state === 'STILL') {
            if (
              currentGroup &&
              currentGroup.state === 'STILL' &&
              currentGroup.addressPrefix === pPrefix
            ) {
              // Same stop, extend duration
              currentGroup.endTime = entryTime
              currentGroup.battery = entry.batteryLevel // Update to latest battery
              // Keep initial time as start time
            } else {
              // Address changed or previously was MOVING -> Close old group, start new STILL group
              if (currentGroup) {
                currentGroup.durationText = formatDuration(
                  currentGroup.endTime - currentGroup.startTime
                )
                processedRows.push(currentGroup)
              }
              currentGroup = {
                employeeName: employeeName,
                time: this.$dayjs(entryTime).format('DD-MM-YYYY hh:mm A'),
                startTime: entryTime,
                endTime: entryTime,
                activityType: activity.activityType || '-',
                action: activity.action || '-',
                state: entry.state || '-',
                lat: coords[1] || entry.lat || '-',
                lng: coords[0] || entry.lng || '-',
                address: pAddress,
                addressPrefix: pPrefix,
                battery: entry.batteryLevel,
                durationText: '0s' // Default if single point
              }
            }
          } else {
            // MOVING or other state -> Close any previous group
            if (currentGroup) {
              currentGroup.durationText = formatDuration(
                currentGroup.endTime - currentGroup.startTime
              )
              processedRows.push(currentGroup)
              currentGroup = null
            }
            // Add current point as standalone
            processedRows.push({
              employeeName: employeeName,
              time: this.$dayjs(entryTime).format('DD-MM-YYYY hh:mm A'),
              activityType: activity.activityType || '-',
              action: activity.action || '-',
              state: entry.state || '-',
              lat: coords[1] || entry.lat || '-',
              lng: coords[0] || entry.lng || '-',
              address: pAddress,
              battery: entry.batteryLevel,
              durationText: '-' // No duration for moving points usually
            })
          }
        })

        // Push remaining group
        if (currentGroup) {
          currentGroup.durationText = formatDuration(currentGroup.endTime - currentGroup.startTime)
          processedRows.push(currentGroup)
        }

        const trackingRows = processedRows.map((row) => ({
          name: row.employeeName,
          time: row.time,
          duration: row.durationText,
          // activityType: row.activityType,
          action: row.action,
          lat: row.lat,
          lng: row.lng,
          address: row.address,
          battery: row.battery,
          state: row.state
        }))

        trackingSheet.addRows(trackingRows)

        // --- SHEET 2: TASK DATA (Derived from Time Series) ---
        const taskSheet = workbook.addWorksheet('Task Data')
        taskSheet.columns = [
          { header: 'Employee Name', key: 'name', width: 25 },
          { header: 'Time', key: 'time', width: 22 },
          { header: 'Action', key: 'action', width: 20 },
          { header: 'Task ID', key: 'taskId', width: 30 },
          { header: 'Case Task ID', key: 'caseTaskId', width: 30 },
          { header: 'Address', key: 'address', width: 45 },
          { header: 'Location', key: 'location', width: 25 }
        ]

        const taskRows = dataToExport
          .filter(
            (entry) =>
              entry.activity &&
              (entry.activity.activityType === 'TASK' ||
                entry.activity.activityType === 'CHECK_IN_OUT' ||
                ['checkIn', 'checkOut', 'taskComplete', 'taskStart'].includes(
                  entry.activity.action
                ))
          )
          .map((entry) => {
            const activity = entry.activity || {}
            const loc = entry.location || {}
            const coords = loc.coordinates || []
            const u = entry.userId || {}
            const employeeName =
              `${u.firstName || ''} ${u.lastName || ''}`.trim() ||
              this.getFullName(this.selectedUserId) ||
              'Unknown'

            return {
              name: employeeName,
              time: this.$dayjs(entry.createdAt || entry.timestamp).format('DD-MM-YYYY hh:mm A'),
              action: activity.action || '-',
              taskId:
                typeof activity.taskDetails === 'string'
                  ? activity.taskDetails
                  : activity.taskDetails?._id || '-',
              caseTaskId:
                typeof activity.caseTaskDetails === 'string'
                  ? activity.caseTaskDetails
                  : activity.caseTaskDetails?._id || '-',
              address: loc.address || '-',
              location: coords.length === 2 ? `${coords[1]}, ${coords[0]}` : '-'
            }
          })

        taskSheet.addRows(taskRows)

        // --- DOWNLOAD ---
        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `Travel_Report_${this.getFullName(this.selectedUserId)}_${date}.xlsx`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.error('Error exporting map data:', error)
        this.$toast.error('Failed to export map data')
      } finally {
        this.exportLoading = false
      }
    },
    updateTeamData(data) {
      const index = this.teamData.indexOf(data)
      if (index !== -1) {
        const newTeamData = this.teamData.splice(index, 1, data)
        return newTeamData
      }
    },
    getFullName(user) {
      if (!user) return 'User'
      // If user is just an ID, try to find in employees list
      if (typeof user === 'string') {
        const found = this.employees?.find((u) => u._id === user)
        if (found) return found.fullName || `${found.firstName} ${found.lastName}`
        return user
      }
      return user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'User'
    },
    toggleDrawer() {
      this.roasterDrawer = !this.roasterDrawer
    },
    isFeatureVisible(feature) {
      return isModuleFeatureAllowed('ATTENDANCE', feature)
    },
    isAttendanceFeature(feature) {
      return isModuleFeatureAllowed('ATTENDANCE_MANAGEMENT', feature)
    },
    updateSelectedDate() {
      if (this.tabs == 1) {
        this.selectedDate = this.$dayjs().endOf('month').format('YYYY-MM-DD')
      }
    },
    openColumnSelect() {
      // Directly open the column select dropdown
      this.$nextTick(() => {
        if (this.$refs.columnSelect && this.$refs.columnSelect.$el) {
          // Find and click the input element to open the dropdown
          const input = this.$refs.columnSelect.$el.querySelector('input')
          if (input) {
            input.click()
          } else {
            // Fallback: click the main element
            this.$refs.columnSelect.$el.click()
          }
        }
      })
    },
    handleTimelineData(data) {
      this.timelineData = data.locationHistory
      this.selectedUserId = data.userId
    },
    isValidObjectId(id) {
      return /^[a-f\d]{24}$/i.test(id)
    },
    handleViewTimeline(user) {
      // 1. Update Global Search Input (Store)
      const userSelection = {
        name: SearchConfig.formatUserName(user),
        empId: user._id,
        empNumber: user.mobile
      }
      console.log(userSelection)
      this.$store.dispatch('updateInputValue', userSelection)

      // 2. Sync selected date for map view from employee filter - Removed as employees filter is gone
      // this.selectedDate = this.employeeSelectedDate

      // 3. Update Route (Search + Tab)
      // This will trigger the search watcher which calls fetchLocationData
      this.$router.push({
        query: {
          ...this.$route.query,
          activeTab: 'map',
          search: user._id
        }
      })
    },
    async fetchLocationData(reporteeId) {
      if (!reporteeId) return

      // Debounce check to prevent multiple calls for the same user/date
      const date = this.selectedDate || this.$dayjs().format('YYYY-MM-DD')
      const requestKey = `${reporteeId}-${date}`
      const now = Date.now()

      if (this.lastLocationFetchKey === requestKey && now - this.lastLocationFetchTime < 1000) {
        return
      }

      this.lastLocationFetchKey = requestKey
      this.lastLocationFetchTime = now

      try {
        const params = {
          date
        }
        const response = await this.$axios.get(`/location-time-series/${reporteeId}`, {
          params
        })
        this.timelineData = response.data?.data?.data || []
        this.selectedUserId = reporteeId
      } catch (error) {
        console.error('Error fetching location data:', error)
      }
    },
    switchToTimelineTab() {
      // Switch to timeline tab
      // Switch to timeline tab or map tab based on availability
      const mapTabIndex = this.visibleTabs.findIndex((tab) => tab.key === 'map')
      if (mapTabIndex !== -1) {
        this.tabs = mapTabIndex
        this.handleTabChange('map')
        return
      }

      // const timelineTabIndex = this.visibleTabs.findIndex((tab) => tab.key === 'timeline')
      // if (timelineTabIndex !== -1) {
      //   this.tabs = timelineTabIndex
      //   this.handleTabChange('timeline')
      // }
    }
  },
  async mounted() {
    const query = { ...this.$route.query }
    if (!query.activeTab) {
      const defaultTab = this.visibleTabs[0]?.key
      if (defaultTab) {
        query.activeTab = defaultTab
        this.$router.replace({ query })
      }
    }
    await this.fetchTaskSteps()
    this.orgConfig = await this.getConfig()
    await this.fetchUsers() // Ensure users are loaded on refresh
    this.isLoad = false
  },
  computed: {
    activeTab() {
      return this.$route.query.activeTab || this.defaultTabKey
    },
    defaultTabKey() {
      return this.visibleTabs[0]?.key || 'attendance'
    },
    currentTab() {
      return this.tabItems[this.tabs]?.component
    },
    iamStatements() {
      return this.$store.state.wfmStatements || []
    },
    canEdit() {
      return (
        hasIamPermission(this.iamStatements, 'team_review.attendance.write') ||
        hasIamPermission(this.iamStatements, 'team_review.roster.assign_shift')
      )
    },
    canWrite() {
      return (
        hasIamPermission(this.iamStatements, 'team_review.attendance.write') ||
        hasIamPermission(this.iamStatements, 'team_review.roster.assign_shift')
      )
    },
    canRead() {
      return (
        hasIamPermission(this.iamStatements, 'team_review.attendance.read') ||
        hasIamPermission(this.iamStatements, 'team_review.roster.read') ||
        hasIamPermission(this.iamStatements, 'team_review.map.read') ||
        hasIamPermission(this.iamStatements, 'team_review.calendar.read')
      )
    },
    canManageColumns() {
      return hasIamPermission(this.iamStatements, 'team_review.attendance.manage_columns')
    },

    tabItems() {
      // console.log('tabItems', TAB_ITEMS.TEAM_REVIEW)
      return TAB_ITEMS.TEAM_REVIEW.map((tab) => ({
        ...tab,
        visibility: true
      }))
    },
    roasterTab() {
      return this.tabItems[this.tabs].roasterComponent
    },
    isExportButtonVisible() {
      return this.isFeatureVisible('DOWNLOAD_REPORT') || this.isFeatureVisible('DOWNLOAD_ROSTER')
    },
    formattedEmployeeDate() {
      // return this.$dayjs(this.employeeSelectedDate).format('DD MMM, YYYY')
      return ''
    },
    formattedMonth() {
      if (this.dateRangeType === 'Daily' || this.activeTab === 'map') {
        return this.$dayjs(this.selectedDate).format('MMMM YYYY')
      } else {
        if (this.customDates.length === 2) {
          const start = this.$dayjs(this.customDates[0]).format('YYYY-MM-DD')
          const end = this.$dayjs(this.customDates[1]).format('YYYY-MM-DD')
          return `${start} to ${end}`
        } else if (this.customDates.length === 1) {
          return this.$dayjs(this.customDates[0]).format('YYYY-MM-DD')
        }
        return this.$dayjs(this.customDates[0]).format('YYYY-MM-DD')
      }
    },
    allTaskStatusSelected() {
      return this.selectedTaskStatus.length === this.taskSteps.length
    },
    someTaskStatusSelected() {
      return this.selectedTaskStatus.length > 0 && !this.allTaskStatusSelected
    },
    icon() {
      if (this.allTaskStatusSelected) return 'mdi-close-box'
      if (this.someTaskStatusSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allColumnSelected() {
      return this.selectedColumns.length === this.subColumnOptions.length
    },
    someColumnSelected() {
      return this.selectedColumns.length > 0 && !this.allColumnSelected
    },
    iconColumn() {
      if (this.allColumnSelected) return 'mdi-close-box'
      if (this.someColumnSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    minDate() {
      const now = this.$dayjs()
      const currentYear = now.year()
      return this.$dayjs().subtract(1, 'year').startOf('month').format('YYYY-MM-DD')
    },
    maxDate() {
      if (this.tabs == 1) {
        const now = this.$dayjs()
        const currentYear = now.year()
        return this.$dayjs().endOf('month').format('YYYY-MM-DD')
      } else {
        return this.$dayjs().format('YYYY-MM-DD')
      }
    },
    renderTable() {
      return this.dateRangeType === 'Custom Date' && this.customDates.length !== 2
    },
    visibleSubColumnOptions() {
      return this.subColumnOptions?.filter((option) => option.visible)
    },
    visibleTabs() {
      return this.tabItems.map((tab) => ({
        key: tab.key,
        label: tab.name,
        icon: tab.icon,
        component: tab.component,
        roasterComponent: tab.roasterComponent,
        permissionKey:
          tab.key === 'attendance'
            ? 'team_review.attendance.read'
            : tab.key === 'map'
            ? 'team_review.map.read'
            : tab.key === 'calendar'
            ? 'team_review.calendar.read'
            : tab.key === 'roaster'
            ? 'team_review.roster.read'
            : null
      }))
    },
    firstSubCaseTabName() {
      if (!this.subCases?.[0]?.subCase) return {}
      const firstSubCase = this.subCases?.[0]?.subCase || {}
      return firstSubCase[0]?.tableTabMapping || {}
    }
  },
  beforeCreate() {
    this.debouncedFetchUsers = () => {}
  },
  created() {
    this.debouncedFetchUsers = debounce(this.fetchUsers, 800)
  }
}
</script>

<style scoped>
::v-deep .tab-content {
  overflow-y: hidden !important;
  height: calc(100vh - 150px) !important;
}

.v-tab:before {
  background-color: transparent;
}

.v-tab {
  font-size: 16px;
}

.chip-text-div {
  max-width: 50%;
  /* outline: 1px solid red; */
}
.v-list {
  padding-top: 0px !important;
}

/* Container for positioning the column selector */
.column-selector-container {
  position: relative;
  display: inline-block;
}

/* Hide the select visually but keep it functional and positioned under the icon */
.hidden-column-select {
  position: absolute;
  top: 40px !important;
  left: 0;
  opacity: 0;
  pointer-events: none;
  width: 28px;
  height: 28px;
  z-index: -1;
}
</style>
